import axios from '../../util/axios';
import '../../util/mock/zh/getParkOperationInfo';

import PopulationLayer from '../../layer/PopulationLayer';
import RevenueLayer from '../../layer/RevenueLayer';
import EnterpriseLayer from '../../layer/EnterpriseLayer';

/**
 * 园区运营
 */
export default class ParkOperation {
    constructor(main) {
        this.main = main;
        this.g2d = main.g2d;
        this.dm = main.g2d.dm();
        this.htAnims = {};
        this.intervalAnims = {};
    }

    /**
     * 初始化 2D 面板上的数据
     */
    init() {
        const dm = this.dm;
        
        // 左侧
        const environmentPanel = this.environmentPanel = dm.getDataByTag('parkOperationEnvironment');
        const overviewPanel = this.overviewPanel = dm.getDataByTag('parkOperationOverview');
        const enterprisePanel = this.enterprisePanel = dm.getDataByTag('parkOperationEnterprise');

        // 右侧
        const facilityPanel = this.facilityPanel = dm.getDataByTag('parkOperationFacility');
        const parkingPanel = this.lightPanel = dm.getDataByTag('parkOperationParking');
        const carAccessPanel = this.energyPanel = dm.getDataByTag('parkOperationCarAccess');

        axios.get('getParkOperationInfo').then(res => {
            this.allParkOperationInfo = res;

            // 左一 环境
            environmentPanel.getChildAt(1).a(res.environmentInfo);
            
            // 左二 总览
            overviewPanel.getChildAt(1).a(res.overviewInfo);

            // 左三 企业
            const enterpriseData = res.enterprise;
            enterprisePanel.getChildAt(1).getChildAt(0).a('value', enterpriseData.register);
            enterprisePanel.getChildAt(1).getChildAt(1).a('value', enterpriseData.enter);

            enterprisePanel.getChildAt(2).getChildAt(0).a('ht.dataSource', enterpriseData.type);
            enterprisePanel.getChildAt(2).getChildAt(1).a('ht.dataSource', enterpriseData.industry);

            // 右一 设施
            facilityPanel.getChildAt(1).a(res.facility);

            // 右二 车位 
            // parkingPanel.getChildAt(2).a('ht.dataSource', res.light);

            // 右三 车辆进出
            const caraccess = res.caraccess.name;
            const caraccessNode = carAccessPanel.getChildAt(2);
            const caraccessNodeSeries = caraccessNode.a('ht.series');
            caraccessNodeSeries[0].name = caraccess[0];
            caraccessNodeSeries[1].name = caraccess[1];

            this.start2DAnim();
        });
        
    }

    /**
     * 启动 2D 上的动画
     */
    start2DAnim() {
        // 先清除动画,避免重复调用 start2DAnim 但未调用过 stop2DAnim 的误操作.
        this.stop2DAnim();
        
    }

    /**
     * 停止移除 2D 上的动画
     */
    stop2DAnim() {
        Object.values(this.htAnims).forEach(anim => {
            anim.pause();
        });
        this.htAnims = {};
    }

    /**
     * 开启人员统计图层
     */
    openPopulationLayer() {
        const map = this.main.pageMap.map;
        let populationLayer = this.populationLayer;
        if(populationLayer) {
            populationLayer.showLayer();
            populationLayer.startLayerAnim();
        }
        else {
            axios.get('getBuildingData').then(res => {
                res.reverse();
                const _data = res.map(v => {
                    v.id += 'population';
                    return v;
                });
                populationLayer = new PopulationLayer(map, _data);
                populationLayer.showLayer();
                populationLayer.startLayerAnim();
                this.populationLayer = populationLayer;
            });
        }
    }

    /**
     * 关闭人员统计图层
     */
    closePopulationLayer() {
        let populationLayer = this.populationLayer;
        if(populationLayer) {
            populationLayer.hideLayer();
            populationLayer.stopLayerAnim();
        }
    }
    
    /**
     * 开启营业额统计图层
     */
     openRevenueLayer() {
        const map = this.main.pageMap.map;
        let revenueLayer = this.revenueLayer;
        if(revenueLayer) {
            revenueLayer.showLayer();
        }
        else {
            axios.get('getBuildingData').then(res => {
                res.reverse();
                const _data = res.map(v => {
                    v.id += 'revenue';
                    return v;
                });
                revenueLayer = new RevenueLayer(map, _data);
                revenueLayer.showLayer();
                this.revenueLayer = revenueLayer;
            });
        }
    }

    /**
     * 关闭营业额统计图层
     */
    closeRevenueLayer() {
        let revenueLayer = this.revenueLayer;
        if(revenueLayer) {
            revenueLayer.hideLayer();
        }
    }

    /**
     * 开启重点企业统计图层
     */
     openEnterpriseLayer() {
        const map = this.main.pageMap.map;
        let enterpriseLayer = this.enterpriseLayer;
        if(enterpriseLayer) {
            enterpriseLayer.showLayer();
            enterpriseLayer.startLayerAnim();
        }
        else {
            axios.get('getBuildingData').then(res => {
                res.reverse();
                const _data = res.map(v => {
                    v.id += 'enterprise';
                    return v;
                });
                enterpriseLayer = new EnterpriseLayer(map, _data);
                enterpriseLayer.showLayer();
                enterpriseLayer.startLayerAnim();
                this.enterpriseLayer = enterpriseLayer;
            });
        }
    }

    /**
     * 关闭重点企业统计图层
     */
    closeEnterpriseLayer() {
        const map = this.main.pageMap.map;
        let enterpriseLayer = this.enterpriseLayer;
        if(enterpriseLayer) {
            enterpriseLayer.hideLayer();
            enterpriseLayer.stopLayerAnim();
        }
    }

    /**
     * 清除关闭所有动画及数据更新
     */
    clear() {
        this.closePopulationLayer();
        this.closeRevenueLayer();
        this.closeEnterpriseLayer();

        this.stop2DAnim();
    }
}